module.exports = __webpack_public_path__ + "static/media/minus.7f280602.svg";